import Hero from './components/Hero';
import LocalFocus from './components/LocalFocus';
import Benefits from './components/Benefits';
import Transformation from './components/Transformation';
import Objections from './components/Objections';
import Statistics from './components/Statistics';
import Support from './components/Support';
import FinalCTA from './components/FinalCTA';
import QuickQuestion from './components/QuickQuestion';
import { ThemeProvider } from './context/ThemeContext';
import { useSEO, getOrganizationSchema, getServiceSchema, getBreadcrumbSchema } from '../../utils/seo';
import CookieBanner from '../../components/CookieBanner';
import SiteFooter from '../../components/feature/SiteFooter';

function HomeSEO() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Seitenschmied – Profiwebsites für kleine Betriebe im Würmtal',
    description: 'Individuelle Websites mit maßgeschneiderten Texten für lokale Betriebe. Persönlich betreut, schnell online, mehr Kunden.',
    keywords: 'website erstellen lassen, kleine unternehmen, seitenschmied, webdesign würmtal, website münchen',
    canonical: siteUrl,
    ogImage: 'https://static.readdy.ai/image/5464a8e208be2c466098e318f0dedf87/06f7ee287cfacc7a314e7ca2f415ab12.png',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getServiceSchema(),
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'Seitenschmied',
          description: 'Individuelle Websites für lokale Betriebe im Würmtal',
          inLanguage: 'de-DE',
          publisher: {
            '@id': `${siteUrl}/#organization`,
          },
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: 'Seitenschmied – Profiwebsites für kleine Betriebe im Würmtal',
          description: 'Individuelle Websites mit maßgeschneiderten Texten für lokale Betriebe. Persönlich betreut, schnell online.',
          inLanguage: 'de-DE',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#organization` },
        },
        getBreadcrumbSchema([
          { name: 'Startseite', url: siteUrl },
        ]),
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Was kostet eine professionelle Website bei Seitenschmied?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Seitenschmied bietet fixe Pakete ohne versteckte Kosten. Die Preise sind transparent und richten sich nach dem gewählten Paket. Ein kostenloses Erstgespräch klärt, welches Paket am besten passt.',
              },
            },
            {
              '@type': 'Question',
              name: 'Wie lange dauert die Erstellung einer Website?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Deine Website ist in wenigen Wochen live – nicht in Monaten. Die genaue Dauer hängt vom gewählten Paket und der Bereitstellung der Inhalte ab.',
              },
            },
            {
              '@type': 'Question',
              name: 'Ist Hosting und Support inklusive?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Ja, bei Seitenschmied sind Hosting, laufender Support und rechtssichere Texte direkt im Paket enthalten. Alles aus einer Hand.',
              },
            },
          ],
        },
      ],
    },
  });

  return null;
}

export default function Home() {
  return (
    <ThemeProvider>
      <HomeSEO />
      <div className="min-h-screen">
        <Hero />
        <LocalFocus />
        <Benefits />
        <Transformation />
        <Objections />
        <Statistics />
        <Support />
        <FinalCTA />
        <QuickQuestion />
        <SiteFooter />
      </div>
      <CookieBanner />
    </ThemeProvider>
  );
}
